import React from "react";
import { APP_NAME } from "../config";
import { IconClose } from "../icons/svg";
import { profile } from "../stores/storages/ProfileStorage";
import mocha from '../img/logo/mocha.png';
import laos from '../img/logo/laos.png';
import { FormattedMessage } from "react-intl";

export default class GrantedNotification extends React.Component {
   constructor(props) {
      super(props);

      this.handleOk = this.handleOk.bind(this);
      this.handleCancel = this.handleCancel.bind(this);
   }

   handleOk() {
      if ('Notification' in window) {
         Notification.requestPermission().then(permission => {
            switch (permission) {
               case 'granted':
                  profile.notification = true;
                  break;
               default:
                  this.handleCancel();
                  break;
            }
         });
      }
      this.handleCancel();
   }

   handleCancel() {
      this.props.onClose();
      profile.deniedNotification = true;
   }

   getIconApp() {
      if (APP_NAME == 'MOCHA' || APP_NAME == 'MOCHA_DEV') {
         return mocha;
      } else {
         return laos;
      }
   }

   render() {
      return (
         <div className="granted-notification ">
            <div className="container">
               <div className="logo">
                  <img src={this.getIconApp()} alt="" />
               </div>
               <div className="content">
                  <div className="title">
                     <FormattedMessage
                        id="granted_notification"
                        defaultMessage="Allow Mocha to display notifications so you won't miss important messages"
                     />
                  </div>
                  <div className="gr-btn">
                     <button className="button-cancel" onClick={this.handleCancel}>
                        <FormattedMessage id="button_cancel" defaultMessage="Cancel" description="Button [Cancel]" />
                     </button>
                     <button className="button-ok" onClick={this.handleOk}>
                        <FormattedMessage id="button_ok" defaultMessage="OK" description="Button [OK]" />
                     </button>
                  </div>
               </div>
               <div className="icon" onClick={this.props.onClose}>
                  <IconClose />
               </div>
            </div>
         </div>
      )
   }
}